// ============================================================
// Teacher Notifications Mock Data
// ============================================================

export const mockTeacherNotifications = [
  {
    id: 't-notif-1',
    teacherId: 'teacher-1',
    title: 'Staff Meeting Tomorrow',
    message: 'Mandatory staff meeting tomorrow at 4:00 PM in the main hall. Please review the agenda attached.',
    type: 'meeting',
    read: false,
    date: '2026-07-21T09:00:00Z',
    priority: 'high',
  },
  {
    id: 't-notif-2',
    teacherId: 'teacher-1',
    title: 'Syllabus Completion Report',
    message: 'Please submit your syllabus completion report for the month of July by the 25th.',
    type: 'circular',
    read: true,
    date: '2026-07-19T10:30:00Z',
    priority: 'medium',
  },
  {
    id: 't-notif-3',
    teacherId: 'teacher-1',
    title: 'Upcoming Holiday',
    message: 'School will remain closed on Friday for Independence Day preparations.',
    type: 'holiday',
    read: true,
    date: '2026-07-18T14:15:00Z',
    priority: 'low',
  },
  {
    id: 't-notif-4',
    teacherId: 'teacher-2',
    title: 'Science Lab Inspection',
    message: 'Science labs will be inspected next week. Ensure all equipment is properly accounted for.',
    type: 'principal',
    read: false,
    date: '2026-07-20T11:00:00Z',
    priority: 'high',
  },
  {
    id: 't-notif-5',
    teacherId: 'teacher-3',
    title: 'English Essay Competition',
    message: 'You have been assigned as the coordinator for the inter-school English essay competition.',
    type: 'circular',
    read: false,
    date: '2026-07-21T08:45:00Z',
    priority: 'medium',
  },
];
